import { render, staticRenderFns } from "./AddFolder.vue?vue&type=template&id=3866ee30&scoped=true&"
import script from "./AddFolder.vue?vue&type=script&lang=js&"
export * from "./AddFolder.vue?vue&type=script&lang=js&"
import style0 from "./AddFolder.vue?vue&type=style&index=0&id=3866ee30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866ee30",
  null
  
)

export default component.exports